import Axios from 'axios'
import { createStore, applyMiddleware, compose } from 'redux'
import { createLogicMiddleware } from 'redux-logic'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { thunk } from 'redux-thunk'
import logics from './logics'
import rootReducer from './reducers'

const persistConfig = {
  key: 'store',
  storage,
  whitelist: ['store']
}

const deps = {
  // injected dependencies for logic
  httpClient: Axios
}

const logicCommonMiddleware = createLogicMiddleware(logics.commons, deps)

const logicRelatedToVehicleMiddleware = createLogicMiddleware(
  logics.relatedToVehicles,
  deps
)

const addCancelToken = () => (next) => (action) => {
  if (action.meta?.cancelable) {
    const { CancelToken } = Axios
    // eslint-disable-next-line no-param-reassign
    action.meta.cancelSource = CancelToken.source()
  }

  return next(action)
}

const pReducer = persistReducer(persistConfig, rootReducer)
const middlewareEnhancer = applyMiddleware(
  thunk,
  addCancelToken,
  logicCommonMiddleware,
  logicRelatedToVehicleMiddleware
)

const composeWithDevTools =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const composedEnhancers = composeWithDevTools(middlewareEnhancer)

const store = createStore(pReducer, composedEnhancers)
const persistor = persistStore(store)
export { persistor, store }
